import { Component } from '@angular/core';
import { CovanceFilterBaseTypeComponent } from './covance-filter-base-type.component';
import { CovanceFilterTextType } from './covance-filter-text-type';

@Component({
    selector: 'covance-filter-text-type',
    template: require('./covance-filter-text-type.component.html')
})
export class CovanceFilterTextTypeComponent extends CovanceFilterBaseTypeComponent<CovanceFilterTextType> {
    constructor(filterType: CovanceFilterTextType) {
        super(filterType);
    }
}